import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Table, TabContent, Nav, NavLink, Button } from "reactstrap";
import swal from "sweetalert";
import Pagination from "react-js-pagination";
import { IoAccessibility } from "react-icons/io5";
import SearchRafiqAttendance from "./SearchRafiqAttendance";
import { ApiEvent } from "../ApiEvent";
import { GetLanguageString, NoResult } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { ButtonGroup } from "reactstrap";
import { RiFileExcel2Line, RiFilePdf2Line } from "react-icons/ri";
import { saveAs } from "file-saver";
import { toast, ToastContainer } from "react-toastify";
import { LoadingSpinner } from "../../../constants/const";
import { useTranslation } from "react-i18next";
import { ShowToast } from "../../shared/ShowToast";
const RafiqWiseEventAttendance = () => {
  const { t } = useTranslation();
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [loading, setLoading] = useState(false);
  const [searchButton, setSearchButton] = useState(false);
  const [data, setData] = useState({});
  const [tab1, setTab1] = useState("active");
  const [tab2, setTab2] = useState("");
  const [pagination, setPagination] = useState({ activePage: 1 });
  const [reportType, setReportType] = useState("");
  const [showReportOptions, setSowReportOptions] = useState(false);

  const toggleShowReportOptions = () => setSowReportOptions(!showReportOptions);

  const overlayRef = useRef(null);

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };
  const buttonStyle = {
    width: "180px",
    height: "100px",
    margin: "0 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "grey",
    fontSize: "1.2rem",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    border: "none",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
    borderRadius: "15px",
    transform: "translateY(0)",
  };
  let tempDate = new Date();
  tempDate.setUTCDate(1);
  const [searchEventWiseAttendanceModel, setSearchEventWiseAttendanceModel] =
    useState({
      unit: { value: loggedInUnitId, lable: "" },
      isSubUnits: true,
      startDate: tempDate,
      endDate: new Date(),
      eventTypeIds: [],
      memberTypeIds: [],
      isAhbab: false,
      activePage: 1,
    });

  useEffect(() => {
    if (searchButton) {
      setLoading(true);
      ApiEvent()
        .GetRafiqWiseEventAttendanceReport(searchEventWiseAttendanceModel)
        .then((res) => {
          setData(res.data);
          setPagination({
            activePage: res.data.activePage,
            pageSize: res.data.pageSize,
            totalItem: res.data.totalItem,
            pageRange: res.data.pageRange,
          });
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  }, [searchButton, searchEventWiseAttendanceModel]);

  const handlePageChange = (pageNumber) => {
    setSearchEventWiseAttendanceModel({
      ...searchEventWiseAttendanceModel,
      activePage: pageNumber,
    });
    setPagination({
      ...pagination,
      activePage: pageNumber,
    });
  };
  const downloadExcel = (reportMemberType) => {
    if (!searchButton) return;

    if (reportMemberType === "ahbab") {
      searchEventWiseAttendanceModel.isAhbab = true;
    }
    if (reportMemberType === "rufqa") {
      searchEventWiseAttendanceModel.isAhbab = false;
    }
    const toastId = toast.loading(t("downloading_excel"));
    ApiEvent()
      .GetRafiqWiseEventAttendanceExcelReport(searchEventWiseAttendanceModel)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "RafiqWiseIjtimaReport.xlsx");
        ShowToast(toastId, "downloaded_excel", "success");
      })
      .catch((err) => {
        console.log(err);
        ShowToast(toastId, "Failed to download Excel.", "error");
      })
      .then(() => {
        setLoading(false);
      });
  };
  const downloadPdf = (reportMemberType) => {
    if (!searchButton) return;

    if (reportMemberType === "ahbab") {
      searchEventWiseAttendanceModel.isAhbab = true;
    } else if (reportMemberType === "rufqa") {
      searchEventWiseAttendanceModel.isAhbab = false;
    }

    const toastId = toast.loading(t("downloading_pdf"));

    ApiEvent()
      .GetRafiqWiseEventAttendancePdfReport(searchEventWiseAttendanceModel)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/pdf",
        });
        saveAs(blob, "RafiqWiseIjtimaReport.pdf");

        ShowToast(toastId, "downloaded_pdf", "success");
      })
      .catch((err) => {
        console.log(err);
        ShowToast(toastId, "Failed to download PDF.", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //#region UseEffect
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        toggleShowReportOptions();
      }
    };

    if (showReportOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [showReportOptions]);
  //#endregion

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="ibox">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="common_generate_report" />}</h5>
        </div>
        <SearchRafiqAttendance
          searchEventWiseAttendanceModel={searchEventWiseAttendanceModel}
          setSearchEventWiseAttendanceModel={setSearchEventWiseAttendanceModel}
          setSearchButton={setSearchButton}
          tab2={tab2}
        />
      </div>
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {searchButton ? (
        <div className="ibox">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="quick_event_reports_button5" />}</h5>

            {showReportOptions && (
              <div style={overlayStyle}>
                <div
                  ref={overlayRef}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    style={buttonStyle}
                    onClick={() => {
                      toggleShowReportOptions();
                      if (reportType === "pdf") {
                        downloadPdf("rufqa");
                      }
                      if (reportType === "excel") {
                        downloadExcel("rufqa");
                      }
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-10px)";
                      e.target.style.boxShadow =
                        "0 10px 15px rgba(0, 0, 0, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <IoAccessibility size={30} color="#35A29F" />
                    <GetLanguageString
                      props={"events_attendance_rufqa_percentage"}
                    />
                  </Button>
                  <Button
                    style={buttonStyle}
                    onClick={() => {
                      toggleShowReportOptions();
                      if (reportType === "pdf") {
                        downloadPdf("ahbab");
                      }
                      if (reportType === "excel") {
                        downloadExcel("ahbab");
                      }
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-10px)";
                      e.target.style.boxShadow =
                        "0 10px 15px rgba(0, 0, 0, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <IoAccessibility size={30} color="#FFCA28" />
                    <GetLanguageString
                      props={"events_attendance_ahbab_percentage"}
                    />
                  </Button>
                </div>
              </div>
            )}

            <ButtonGroup className={GetCustomStyles().btn_style}>
              <Button
                color="default"
                size="sm"
                onClick={() => {
                  toggleShowReportOptions();
                  setReportType("excel");
                }}
              >
                <RiFileExcel2Line
                  size={15}
                  color="#009440"
                  style={{ marginRight: 3, marginBottom: 1 }}
                />
                {<GetLanguageString props="member_report_export_excel" />}
              </Button>
              <Button
                color="default"
                size="sm"
                onClick={() => {
                  toggleShowReportOptions();
                  setReportType("pdf");
                }}
              >
                <RiFilePdf2Line
                  size={15}
                  color="#FF0000"
                  className={GetCustomStyles().fa_style}
                />
                {<GetLanguageString props="member_report_export_pdf" />}
              </Button>
            </ButtonGroup>
          </div>
          <div className="ibox-content">
            <Row>
              <Col md="12">
                <div className="tabs-container">
                  <Nav tabs>
                    <li>
                      <NavLink
                        to="#"
                        className={tab1}
                        onClick={() => {
                          setTab1("active");
                          setTab2("");
                          setSearchEventWiseAttendanceModel({
                            ...searchEventWiseAttendanceModel,
                            isAhbab: false,
                            activePage: 1,
                          });
                        }}
                      >
                        <GetLanguageString props="sidebar_member" />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="#"
                        className={tab2}
                        onClick={() => {
                          setTab1("");
                          setTab2("active");
                          setSearchEventWiseAttendanceModel({
                            ...searchEventWiseAttendanceModel,
                            isAhbab: true,
                            activePage: 1,
                          });
                        }}
                      >
                        <GetLanguageString props="ahbab" />
                      </NavLink>
                    </li>
                  </Nav>
                  <TabContent>
                    <div
                      role="tabpanel"
                      id="tab-1"
                      className={"tab-pane " + tab1}
                    >
                      <ShowData
                        loading={loading}
                        data={data}
                        handlePageChange={handlePageChange}
                        pagination={pagination}
                        tab2={tab2}
                      />
                    </div>
                    <div
                      role="tabpanel"
                      id="tab-2"
                      className={"tab-pane " + tab2}
                    >
                      <ShowData
                        loading={loading}
                        data={data}
                        handlePageChange={handlePageChange}
                        pagination={pagination}
                        tab2={tab2}
                      />
                    </div>
                  </TabContent>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default RafiqWiseEventAttendance;

const ShowData = ({ loading, data, handlePageChange, pagination, tab2 }) => {
  const recordIndex = pagination.pageSize * (pagination.activePage - 1) + 1;

  return (
    <div className="panel-body ibox-center">
      {!loading ? (
        data !== undefined &&
        data !== null &&
        data?.columns !== null &&
        data?.columns?.length !== 0 &&
        data?.memberList !== undefined &&
        data?.memberList !== null &&
        data?.memberList.length !== 0 &&
        Object.keys(data).length !== 0 ? (
          <Table className="table-bordered m-b-none">
            <thead>
              <tr>
                <th>#</th>
                <th>
                  <GetLanguageString props="common_name" />
                </th>
                {tab2 === "active" ? null : (
                  <th className="text-center">
                    <GetLanguageString props="settings_member_type" />
                  </th>
                )}
                <th className="text-center">
                  <GetLanguageString props="unit_unit_table" />
                </th>
                {data?.columns?.map((record, index) => {
                  return (
                    <th className="text-center ur" key={index}>
                      <Row>
                        <Col md="4"></Col>
                        <Col md="4">
                          <h3>{record.name} </h3>
                        </Col>
                        <Col md="1" className="m-1">
                          <span
                            className="label label-success"
                            style={{ borderRadius: "50%" }}
                          >
                            {record.eventCounts}
                          </span>
                        </Col>
                        <Col md="4"></Col>
                      </Row>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data?.memberList?.map((item, index) => {
                let unitName = item.unitName?.split("/");
                return (
                  <tr key={index}>
                    <td>{index + recordIndex}</td>
                    <td className="ur">{item.memberName}</td>
                    {tab2 === "active" ? null : (
                      <td className="text-center">
                        {
                          <Button
                            size="xxs"
                            color="info"
                            className="label label-info m-r-xs"
                          >
                            <h5 className="ur">{item.memberType}</h5>
                          </Button>
                        }
                      </td>
                    )}

                    <td className="ur">
                      <ol className="breadcrumb">
                        {unitName?.map((item1, index1) => {
                          return (
                            <li
                              className={
                                GetSelectedLanguage() === "ur"
                                  ? "breadcrumb-item-ur"
                                  : "breadcrumb-item"
                              }
                              key={index1}
                            >
                              <span>{item1}</span>
                            </li>
                          );
                        })}
                      </ol>
                    </td>
                    {item?.memberDetails?.map((record, index1) => {
                      return (
                        <td className="text-center" key={index1}>
                          {record.percentage
                            ? record.percentage.toFixed(2) + "%"
                            : "0.0%"}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="20">
                  <ul className={GetCustomStyles().page_style}>
                    <Pagination
                      activePage={pagination.activePage}
                      itemsCountPerPage={pagination.pageSize}
                      totalItemsCount={pagination.totalItem}
                      pageRangeDisplayed={pagination.pageRange}
                      onChange={handlePageChange}
                    />
                  </ul>
                </td>
              </tr>
            </tfoot>
          </Table>
        ) : (
          <NoResult />
        )
      ) : (
        LoadingSpinner()
      )}
    </div>
  );
};
